const pollFor = (propName, msInterval, resolve) => {
	window[propName] ?
		setTimeout(resolve, 10) :
		setTimeout(() => pollFor(propName, msInterval, resolve), 100);
};

export default (propName, msInterval) => {
	return new Promise(function(resolve, reject) {
		pollFor(propName, msInterval, resolve);
	});
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/utils/waitFor.js